export const UPLOADED_CERT = 'upload';
export const GENERATED_CERT = 'generate';

export const CERTIFICATE_FILE_TYPE = {
  PEM: 'pem',
  CRT: 'crt',
  CER: 'cer',
  DER: 'der',
  P7B: 'p7b',
  P7C: 'p7c',
  PFX: 'pfx',
  P12: 'p12'
};

export const PRIVATE_KEY_FILE_TYPE = {
  PEM: 'pem',
  KEY: 'key',
  DER: 'der'
};

export const CERTIFICATE_FILE_TYPE_FILTER = Object.values(CERTIFICATE_FILE_TYPE).map(type => `.${type}`).join(',');

export const PRIVATE_KEY_FILE_TYPE_FILTER = Object.values(PRIVATE_KEY_FILE_TYPE).map(type => `.${type}`).join(',');
